export default __webpack_public_path__ + "static/media/tumbler.e78f9adb.png";